module.exports = __webpack_public_path__ + "companies-frontend-b21b3468/free-cover-3afb766bab04848423d6efdb4f226321.svg";